import React from 'react'
import { string } from 'prop-types'

const JobReportButton = ({ jobId }) => {
  const onReport = (e) => {
    e.preventDefault()
    e.target.disabled = true

    axios.post('/api/internal/projects/report', { id: jobId })
      .then(onReportSuccess)
      .catch(onReportFailure)
  }

  const onReportSuccess = (response) => {
    const message = `${response.data.included[0].attributes.title} has successfully been reported`

    App.events.publish('app:notification:flash:success', message)
  }

  const onReportFailure = (error) => {
    return App.events.publish('app:notification:flash:error', error.response.data.error)
  }

  return (
    <div className="project-report__button">
      <button onClick={onReport} type="button" className="btn btn-primary btn-block angle-left">Report</button>
    </div>
  )
}

JobReportButton.propTypes = {
  jobId: string.isRequired,
}

export default JobReportButton
